import { useEffect } from "react";

const useNativeConfirmBeforeUnload = (shouldBlock: boolean = true) => {
  useEffect(() => {
    const handleBeforeUnload = (ev: BeforeUnloadEvent) => {
      if (!shouldBlock) return;

      ev.preventDefault();
      // eslint-disable-next-line no-param-reassign
      ev.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [shouldBlock]);
};

export default useNativeConfirmBeforeUnload;
